import { createFileRoute } from '@tanstack/react-router';

import { requireAdmin } from '@/components/admin/require-admin.ts';
import { AwardTemplatesPage } from '@/views/admin/award-templates-page.tsx';

export const Route = createFileRoute('/admin/awards')({
  beforeLoad: requireAdmin,
  component: AwardTemplatesPage,
});
